// extracted by mini-css-extract-plugin
export default {"bold":"applications-components-HeaderApp-components-RegionsList-regions-list-module__bold"};
    if(module.hot) {
      // 1782397803607
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  